import type { GoalWithIds, GoalWithId } from '../../../../../../../common/types';

export const reorderList = (list: GoalWithIds, startIndex: number, endIndex: number) => {
	const result = Array.from<GoalWithId>(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

export const appendNewGoal = (list: GoalWithIds, newGoal: GoalWithId) => {
	const result = Array.from<GoalWithId>(list);
	return [...result, newGoal] as const;
};
